<template>
  <div class="container">
    <modal id="addCartModal" v-if="selectedArticle">
      <div slot="body" class="modal-body add-cart-box text-center">
        <p class="html-content" v-html="translations.addToCartSuccessMessage"></p>
        <h4 id="productTitle">
          {{ selectedArticle.title }}
        </h4>
        <img
          :src="`${baseUrl}${selectedArticle.highlightedImageUrl}`"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
          v-if="selectedArticle.highlightedImageUrl"
        />
        <img
          v-else
          src="assets/images/no-image.jpg"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
        />
        <div class="btn-actions">
          <router-link :to="{ name: 'ShoppingCart' }" data-dismiss="modal">
            <button class="btn-primary">{{translations.goToShoppingCart}}</button>
          </router-link>
          <button class="btn-primary" data-dismiss="modal">
            {{translations.continueShopping}}
          </button>
        </div>
      </div>
    </modal>
    <modal id="quick-preview-article" v-if="quickArticle">
      <div class="modal-body" slot="body">
        <quick-preview :key="quickArticle.id"/>
      </div>
    </modal>
    <section class="product-panel mt-6">
      <div class="section-title">
        <h2>{{ translations.recentlyViewdItems }}</h2>
      </div>
      <VueSlickCarousel v-bind="slickSettings" v-if="articles && articles.length > 0">
        <div
          v-for="item in articles"
          :key="item.id"
        >
          <div
            class="product-wrapper product-default inner-quickview inner-icon"
          >
            <figure>
              <router-link
                :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }"
              >
                <Photo
                  :src="`${baseUrl}${item.highlightedImageUrl}`"
                  v-if="item.highlightedImageUrl"
                />
                <Photo
                  src="assets/images/no-image.jpg"
                  v-else
                />
              </router-link>

              <div class="btn-icon-group">
                <button class="btn-icon btn-add-cart" @click="addToCart(item)">
                  <i class="sicon-equalizer" v-if="item.hasAttributes" />
                  <i class="icon-bag" v-else />
                </button>
              </div>
              <button
                class="btn btn-sm btn-quickview"
                data-toggle="modal"
                @click="getQuickArticle(item.id)"
              >
                {{ translations.quickPreview }}
              </button>
            </figure>
            <div class="product-details">
              <div class="category-wrap">
                <div class="category-list">
                  <a class="product-category">{{ item.brand }}</a>
                </div>
                <a href="#" class="btn-icon-wish"><i class="icon-heart"></i></a>
              </div>
              <h2 class="product-title">
                <router-link
                  :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }"
                >
                  {{ item.title }}
                </router-link>
              </h2>
              <div>{{ translations.forms.labels.code }}: {{ item.code }}</div>
              <div class="ratings-container">
                <star-rating
                  :inline="true"
                  :star-size="15"
                  :read-only="true"
                  :show-rating="false"
                  :rating="item.rating"
                />
              </div>
              <!-- End .product-container -->
              <div class="price-box" v-if="item.disableSelling === false">
                <span class="product-price">
                  {{ (item.salePrice || item.price) | money3WithCurrency }}
                </span>
                <span
                  class="old-price"
                  v-if="item.salePrice < item.price && item.salePrice"
                >
                  {{ item.price | money3WithCurrency }} KM
                </span>
              </div>
              <div v-else class="d-flex w-100 justify-content-center">
                <button
                  class="paction add-cart w-100 mx-1"
                  @click="showOutOfStockModal(item)"
                >
                {{ translations.availableOnRequest }}
                </button>
              </div>
            </div>
            <!-- End .product-details -->
          </div>
        </div>
      </VueSlickCarousel>
    </section>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating';

import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';

import { translations } from '@/mixins';
import config from '@/config';
import helpers from '@/services/helpers';
import api from '@/services/api';
import slugify from '@/filters/slugify';

import Modal from '@/components/shared/modal/Modal.vue';
import QuickPreview from '@/components/shared/article/QuickPreview.vue';
import Photo from '@/components/shared/Image.vue';

export default {
  name: 'RecentArticles',
  mixins: [translations],
  components: {
    StarRating,
    VueSlickCarousel,
    QuickPreview,
    Modal,
    Photo,
  },
  data() {
    return {
      slickSettings: {
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          // {
          //   breakpoint: 576,
          //   settings: {
          //     slidesToShow: 1,
          //     slidesToScroll: 1,
          //   },
          // },
        ],
      },
      selectedArticle: null,
    };
  },
  computed: {
    articles() {
      return this.$store.getters.getRecentArticles;
    },
    baseUrl() {
      return config.baseUrl;
    },
    quickArticle() {
      return this.$store.getters.getQuickArticle;
    },
    allowOrderingStockZero() {
      return this.$store.getters.getAllowOrderingStockZero;
    },
  },
  methods: {
    slugify,
    addToCart(item) {
      if (item.hasAttributes || (!item.stockAmount && !this.allowOrderingStockZero)) {
        this.$router.push({ name: 'Article', params: { id: item.id, slug: slugify(item.title) } });
        return;
      }
      this.selectedArticle = item;
      api
        .addToShoppingCart({
          articleId: item.id,
          quantity: item.minOrderQuantity || 1,
        })
        .then(() => {
          this.$toast.info(helpers.getAddToCartToastMessage(item));
          $('#addCartModal').modal('show');
          this.$store.dispatch('getShoppingCart');
        }).catch((err) => {
          this.$toast.error(err.response.data.info);
          this.$store.dispatch('getShoppingCart');
          $('#addCartModal').modal('hide');
        });
    },
    getQuickArticle(articleId) {
      this.$store.dispatch('getQuickViewArticle', articleId).then(() => {
        this.$store.dispatch('getArticleVariations', articleId).then(() => {
          this.$store.dispatch('getAttributes', { retrieveAll: true });
          $('#quick-preview-article').modal('show');
        });
      });
    },
    showOutOfStockModal(item) {
      const articleId = item?.articleId || item?.id;
      if (!articleId) return;

      this.$store.dispatch('showOutOfStockModal', { articleId });
    },
  },
  mounted() {
    this.$store.dispatch('getRecentArticles', helpers.getRecentArticles());
  },
};
</script>
<style lang="scss" scoped>
.product-wrapper {
  padding: 15px;
  border-right: 1px solid #e7e7e7;
  &:last-child {
    border-left: none;
  }
}

.product-default .product-title,
.product-default a {
  display: block;
  width: 100%;
}

.btn-icon-wish {
  cursor: pointer;

  &.active {
    color: red;
  }
}

.html-content a {
  color: #3598DB;
}
</style>
